<template>
  <v-container
    class="dashboard"
  >
    <div class="top">
      <WeatherBoard
        class="weather"
      />
    </div>

    <DoubleCard
      ref="chartBoard"
      class="chart"
    >
      <FutureBarLine
        :daily-visits="dailyVisits"
        :daily-amount="dailyAmount"
        :appointed="appointed"
        :deadlines="deadlines"
        :warning-bar="warningBar"
      />
    </DoubleCard>
    <ActionPanel
      :tank-info="tankInfo"
      :yearly-data="yearly"
      class="action-panel"
    />
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ActionPanel, WeatherBoard } from './components'
import { FutureBarLine } from './components/charts'
import { DoubleCard } from '@/components/ui'

export default {
  components: {
    WeatherBoard,
    FutureBarLine,
    ActionPanel,
    DoubleCard
  },
  computed: {
    ...mapState('dashboard', ['selectedSpan', 'yesterdayData', 'tankInfo', 'yearly']),
    ...mapGetters('list', ['selectedNum', 'selectedOilingCapacity', 'leftDeadlines', 'deliveryForecast']),
    dailyVisits () {
      return [this.yesterdayData.count, this.selectedNum, ...this.deliveryForecast.slice(1).map(el => el.ids.size)]
    },
    dailyAmount () {
      return [this.yesterdayData.amount, this.selectedOilingCapacity, ...this.deliveryForecast.slice(1).map(el => el.oilingCapacity)]
    },
    appointed () {
      return [null, ...this.deliveryForecast.map(el => el.appointed)]
    },
    deadlines () {
      return [null, ...this.deliveryForecast.map(el => el.deadline)]
    },
    warningBar () {
      return [null, this.leftDeadlines]
    }
  }
}
</script>
<style lang="scss" scoped>
.dashboard {
  position: relative;
  height: 75vh;
  min-height: 610px;
  padding-bottom: 0;
  display: grid;
  grid-template-columns: minmax(560px, 1fr) 290px;
  grid-template-rows: 140px minmax(0, 1fr);
  gap: 9px;
  justify-items: stretch;
  align-items: stretch;
}
.top {
  position: relative;
  grid-column: 1 / span 1;
  grid-row: 1 / span 1;
}
.weather {
  height: 100%;
}
.chart {
  grid-column: 1 / span 1;
  grid-row: 2 / span 1;
}
.action-panel {
  grid-column: 2 / span 1;
  grid-row: 1 / span 2;
}
</style>
